/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import { baseUrl } from '@/model/storage/index'
import unitSet from '@/model/storage/UnitSet'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    form: false,
    header: false,
  },
  name: {
    displayName: 'resourceName',
  },
  defaultBarcode: {},
  resourceUnitSetId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          return await unitSet.getList(true)
        },
        itemText: 'name',
      },
    },
  },
  lowestUnitPrice: {
    type: IKDataEntity.Types.Float,
    formConfig: {
    },
  },
  unitDisplay: {
    displayName: 'currentCount',
    formConfig: {
      default: 0,
    },
    form: false,
  },
}

const root = 'dishResource'

const config = {
  add: function (item) {
    return hillo.jsonPost(baseUrl + root + '/create', item, {
      showLoading: true,
    })
  },
  edit: function (item) {
    return hillo.jsonPost(baseUrl + root + '/edit/' + item.id, item, {
      showLoading: true,
    })
  },
  remove: function (id) {
    return hillo.post(baseUrl + root + '/delete/' + id,
      { id: id },
    )
  },
  load: async function () {
    const arr = (await hillo.jsonPost(baseUrl + root + '/getList', {}))
      .data
    return arr.map(it => {
      return {
        ...it.dishResource,
        ...it,
      }
    })
  },
}

export default IKDataEntity.ModelFactory(entity, config)
